import { ArrowRightOutlined, FormOutlined } from '@ant-design/icons';
import { Button, Form, Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { LANGUAGES } from '../../constants';

import PhoneInput from 'react-phone-input-2';
import { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-input-2/lib/style.css';

import './style.less';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { get } from '../../utils/helpers';
import { take } from 'rxjs';

const initalFormValue = {
  language: 'en',
};

const CreateForm = ({
  form,
  loading,
  whatsappNumber,
  setWhatsappNumber,
  createTemplateId,
  onSubmit,
}) => {
  const [countryCode, setCountryCode] = useState('us');
  const [whatsappError, setWhatsappError] = useState(false);
  const language = useSelector((state) => state.user.language);
  const { t } = useTranslation();

  useEffect(() => {
    // set/change language inputfield on dashboard language change
    if (language) form.setFieldsValue({ language });
  }, [language, form]);

  useEffect(() => {
    if (!whatsappNumber) {
      const sub$ = get('https://retrieve.whatsform.com/')
        .pipe(take(1))
        .subscribe((resp) => {
          if (resp) {
            const countryCode = resp.country || 'us';
            setCountryCode(countryCode.toLowerCase());
          }
        });
      return () => {
        if (sub$) sub$.unsubscribe();
      };
    }
    if (whatsappNumber) {
      form.setFieldsValue({ number: whatsappNumber });
    }
  }, [whatsappNumber, form]);

  const onPhoneNumberChange = (number) => {
    setWhatsappNumber(number);
    form.setFieldsValue({ number });
    const valid = isValidPhoneNumber(`+${number}`);
    if (!valid) setWhatsappError(true);
    else setWhatsappError(false);
  };

  const onFinish = (values) => {
    if (whatsappError) {
      form.setFields([
        {
          name: 'number',
          errors: ['Please enter a valid number'],
        },
      ]);
      return;
    }

    localStorage.setItem('wfNumber', whatsappNumber);

    onSubmit(values);
  };

  // const nameInputRef = React.useRef(null);
  // const onNameFocus = (event) => {
  //   if (nameInputRef.current && event.target && !form.isFieldTouched('name'))
  //     nameInputRef.current.focus({ cursor: 'all' });
  // };

  return (
    <div className="Create-Form">
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        className="form-container"
        initialValues={initalFormValue}
        onError={(e) => console.log(e)}
      >
        <Form.Item label={t('create.whatsAppNo', 'WhatsApp Number')} style={{ flex: 1 }}>
          <PhoneInput
            autoFormat="false"
            country={countryCode}
            enableSearch="true"
            placeholder=""
            value={whatsappNumber}
            disableSearchIcon="false"
            preferredCountries={['us', 'in', 'br', 'gb']}
            onChange={onPhoneNumberChange}
            enableLongNumbers="true"
            inputClass="ant-input ant-input-lg"
            inputStyle={{ width: '100%' }}
          />

          <Form.Item
            name="number"
            noStyle
            rules={[
              {
                required: true,
                message: 'number is required',
              },
            ]}
          >
            <Input style={{ display: 'none' }} />
          </Form.Item>
        </Form.Item>
        <Form.Item label={t('create.language', 'Language')} name="language" style={{ flex: 1 }}>
          <Select showSearch size="large" style={{ height: '50px' }}>
            {LANGUAGES.map((l) => (
              <Select.Option key={l.code} value={l.code}>
                {l.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item className="button-container">
          <Button type="primary" htmlType="submit" loading={loading} size="large">
            {createTemplateId ? (
              <>
                Create <FormOutlined style={{ marginLeft: 12 }} />
              </>
            ) : (
              <>
                {t('common.next', 'Next')} <ArrowRightOutlined style={{ marginLeft: 12 }} />
              </>
            )}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateForm;
